import client from '../../providers/fetchClient'

export const createTicket = data => client.post('/v3/campaign-contacts', data)

export const updateTicket = (id, data) => client.put(`/v3/campaign-contacts/${id}`, data)
